import * as React from 'react';
import { PK } from 'common/types';

import { useSaveSeriesBlog } from '../hooks';
import { useSeriesDetails } from 'modules/series/queries';
import BlogsPicker from './BlogsPicker';

type Props = {
  pk?: PK;
};

const SeriesBlogPicker = ({ pk }: Props) => {
  const { data } = useSeriesDetails(pk);
  const blog_pk = data?.blog_pk;
  const { save, isLoading, isError, isSuccess } = useSaveSeriesBlog(pk);
  const saveStatus = { isLoading, isError, isSuccess };

  const handleSave = (blogsPks: PK[]) => {
    save(blogsPks, data);
  };

  return (
    <BlogsPicker blog_pk={blog_pk} pk={pk} onSave={handleSave} saveStatus={saveStatus} />
  );
};

export default SeriesBlogPicker;
